export enum IssueType {
    Message,
    Warning,
    Error
}